import { FC } from 'react';

import { Backdrop, Drawer as DrawerMui, DrawerProps } from '@mui/material';

import { IDrawerProps as IProps } from './types';

const PAPER_PROPS: DrawerProps['PaperProps'] = {
  sx: {
    position: 'absolute',
    borderLeft: 'none',
    left: { xs: 0, sm: 'unset' },
  },
};

const MODAL_PROPS: DrawerProps['ModalProps'] = {
  sx: { position: 'absolute' },
  keepMounted: true,
};

const BACKDROP_SX: DrawerProps['sx'] = {
  zIndex: (theme) => theme.zIndex.drawer - 1,
  position: 'absolute',
  inset: 0,
};

export const Drawer: FC<IProps> = ({ children, open, anchor = 'right', onClose, ...props }) => {
  return (
    <>
      <DrawerMui
        {...props}
        open={open}
        variant="persistent"
        anchor={anchor}
        onClose={onClose}
        PaperProps={PAPER_PROPS}
        ModalProps={MODAL_PROPS}
      >
        {children}
      </DrawerMui>
      <Backdrop open={Boolean(open)} sx={BACKDROP_SX} onClick={onClose} />
    </>
  );
};
